import { render, staticRenderFns } from "./fullscreen.vue?vue&type=template&id=a1c5bfe8"
import script from "./fullscreen.vue?vue&type=script&lang=js"
export * from "./fullscreen.vue?vue&type=script&lang=js"
import style0 from "./fullscreen.vue?vue&type=style&index=0&id=a1c5bfe8&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1c5bfe8')) {
      api.createRecord('a1c5bfe8', component.options)
    } else {
      api.reload('a1c5bfe8', component.options)
    }
    module.hot.accept("./fullscreen.vue?vue&type=template&id=a1c5bfe8", function () {
      api.rerender('a1c5bfe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/fullscreen/fullscreen.vue"
export default component.exports